import type { AgentFeature, AgentFeatureToggle } from "../agent-sdk-types.js";

const CLAUDE_FAST_MODE_SUPPORTED_MODEL_PREFIXES = ["claude-opus-"] as const;

export const CLAUDE_FAST_MODE_FEATURE: Omit<AgentFeatureToggle, "value"> = {
  type: "toggle",
  id: "fast_mode",
  label: "Fast",
  description: "Priority inference for faster responses",
  tooltip: "Toggle fast mode",
  icon: "zap",
};

function normalizeClaudeModelId(modelId: string | null | undefined): string | null {
  const normalized = typeof modelId === "string" ? modelId.trim() : "";
  return normalized.length > 0 ? normalized : null;
}

export function claudeModelSupportsFastMode(modelId: string | null | undefined): boolean {
  const normalizedModelId = normalizeClaudeModelId(modelId);
  if (!normalizedModelId) {
    return false;
  }
  return CLAUDE_FAST_MODE_SUPPORTED_MODEL_PREFIXES.some((prefix) =>
    normalizedModelId.startsWith(prefix),
  );
}

export function buildClaudeFeatures(input: {
  modelId: string | null | undefined;
  fastModeEnabled: boolean;
}): AgentFeature[] {
  const features: AgentFeature[] = [];

  if (claudeModelSupportsFastMode(input.modelId)) {
    features.push({
      ...CLAUDE_FAST_MODE_FEATURE,
      value: input.fastModeEnabled,
    });
  }

  return features;
}
